export const useUrlManagement = () => {
  const removeFirstVisitParam = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete("firstVisit");
    window.history.replaceState({}, "", url.toString());
  };

  return {
    removeFirstVisitParam,
  };
};
